import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalAction } from "./interfaces/local-action";
import { LocalActionsWhere } from "./interfaces/local-actions-where";
import { Generic } from "../../shared/models/generic";
import { FormButton } from "../../shared/models/form-button";


@Injectable({
    providedIn: 'root'
})
export class LocalActionsService{
    private actions$ = new BehaviorSubject<Record<string, LocalAction|Generic>>({});
    private createActionSubject = new BehaviorSubject<FormButton|Generic>({});

    watchActions(where: LocalActionsWhere): Observable<LocalAction|Generic>{
        return this.actions$.asObservable().pipe(
            map(allActions => allActions[where] ?? { localActions: [] }),
        );
    }

    watchAllActions(): Observable<LocalAction|Generic>{
        return this.actions$.asObservable().pipe(
            map(allActions => ({
                localActions: Object.values(allActions)
                    .map(action => action.localActions ?? [])
                    .flat()
            })),
        );
    }

    sendActions(actions: LocalAction|Generic): void{
        const prevActions = this.actions$.value;
        this.actions$.next({
            ...prevActions,
            [actions.where]: actions
        });
    }

    clearActions(where: LocalActionsWhere): void {
        this.sendActions({
            localActions: [],
            where
        });
    }

    watchCreateAction(): Observable<FormButton|Generic>{
        return this.createActionSubject.asObservable();
    }

    sendCreateAction(actions: FormButton|Generic): void{
        this.createActionSubject.next(actions);
    }
}
